<template>
  <div class="default-card">
    <div class="default-card-body">
      <div
        v-if="includeHeader || headerText"
        class="default-card-head"
      >
        <h1 v-if="headerText">
          {{ headerText }}
        </h1>
        <slot name="card-header-actions" />
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    includeHeader: {
      type: Boolean,
      default: false,
    },
    headerText: {
      type: [String, null],
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.default-card {
  border-radius: 10px;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.05);
  border: none !important;
  position: relative;
  background-color: #ffffff;

  .default-card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;

    h1 {
      font-style: normal;
      font-weight: 700;
      font-size: 24px;
      line-height: 34px;
      margin-bottom: 0;
    }
  }

  .default-card-body {
    padding: 15px 20px;
  }
}
</style>
